import {
  faFileAlt,
  faUser,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUserProfile } from "../../../store/userProfile";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import logo from "../../../assets/images/logoTrixie.png";
import "./Header.css";

function Header({ onFilesButtonClick, toggleMenu }) {
  const realm = useSelector((state: any) => state.userProfile.realm);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const location = useLocation();

  const logout = () => {
    dispatch(clearUserProfile());
    navigate("/");
  };

  const handleFeedbackClick = () => {
    window.open("https://forms.gle/XYojH6FjUPqCUyiy5", "_blank");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <header className="header">
      {location.pathname === "/chat" && (
        <>
          <button className="menu-button" onClick={toggleMenu}>
            <FontAwesomeIcon icon={faClockRotateLeft} />
          </button>
        
        </>
      )}
      <Link to="/chat">
      <img src={logo} alt="TutorIA Logo" className="logo" />
      </Link>
      <div className="button-container">
        <button className="files-button" onClick={onFilesButtonClick}>
          <FontAwesomeIcon icon={faFileAlt} />
          <span className="button-text"> Mis Archivos</span>
        </button>
        <div className="perfil-button-container" ref={dropdownRef}>
          <button className="perfil-button" onClick={toggleDropdown}>
            <FontAwesomeIcon icon={faUser} />
            <span className="button-text text-perfil-button">Mi perfil</span>
          </button>
          {isDropdownOpen && (
            <DropdownMenu
              realm={realm}
              onFeedbackClick={handleFeedbackClick}
              onLogout={logout}
            />
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
